export const boxShadow = '0px 4px 30px #e2e0cf';
